export enum UserEnum {
  vendor = 0,
  customer = 1,
  credit = 3, // Credit role
  editor = 90,
  admin = 100,
  sales = 7,
}
